export default __webpack_public_path__ + "static/preview-platform-241dd2013017b92d321887db76d84e73.mp4";